import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import routes from './routes'
import { SAVE_ROUTE } from '../store/mutation-types'
import { isInMiniProgram, isWechat } from '@/libraries/util'
import * as webUni from '@/plugins/webview.js'
Vue.use(VueRouter)

const router = new VueRouter({ mode: 'history', base: '/wechat/jj2024', routes,
  // 关键修复：每次路由切换时滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

// 子路由名称列表
const childRouteNames = ['intro', 'vote', 'rank', 'enroll', 'vote.detail', '404']
// menu_id 到路由名称的映射（与 ShowView 中的 names 保持一致）
const menuIdToRouteName = {
  1: 'intro',
  2: 'vote',
  3: 'rank',
  4: 'enroll'
}

// 获取默认子路由名称（根据后台配置的 menu_id）
function getDefaultChildRoute() {
  const detail = store.state.detail
  if (!detail || !detail.st_footer) {
    // 如果没有配置，返回第一个（intro）
    return Object.values(menuIdToRouteName)[0]
  }
  
  const menuId = detail.st_footer.menu_id
  if (menuId !== undefined && menuId !== null) {
    // 处理 menu_id 可能是字符串或数字的情况
    const menuIdNum = Number(menuId)
    const routeName = menuIdToRouteName[menuIdNum]
    if (routeName) {
      return routeName
    }
  }
  // 如果没有配置或配置无效，返回第一个（intro）
  return Object.values(menuIdToRouteName)[0]
}

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  store.commit(SAVE_ROUTE, { from: from.name, to: to.name })

  // 防止死循环：如果从子路由返回到 show，且已有数据，不再重定向
  if (to.name === 'show' && from.name && childRouteNames.includes(from.name)) {
    // 检查是否已经有活动数据
    const detail = store.state.detail
    if (!detail || !detail.st_footer) {
      // 没有数据时才重定向
      if (isInMiniProgram()) {
        if (webUni && webUni.navigateBack) {
          webUni.navigateBack()
          next(false)
          return
        }
      } else {
        const defaultRoute = getDefaultChildRoute()
        next({
          name: defaultRoute,
          query: to.query,
          replace: true
        })
        return
      }
    } else {
      // 已有数据时，直接允许访问 /show，不再重定向
      next()
      return
    }
  }

  next()
})

// 路由切换后，重新配置微信分享
router.afterEach((to, from) => {
  // 只在微信环境中重新配置分享
 if (isWechat()) {
    // 延迟执行，确保组件已挂载
    setTimeout(() => {
      try {
        // 动态导入 share 函数并执行
        import('@/libraries/share').then(({ share }) => {
          share()
        })
      } catch (error) {
        console.error('分享配置失败:', error)
      }
    }, 150)
  }
})

export default router